<template>
  <div :class="['modal', { 'is-active': isOpen }]">
    <div class="modal-background" @click="closeModal()" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Εισερχόμενη Επικοινωνία</p>
        <button class="delete" @click="closeModal()" />
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">Αποδέκτης</label>
          <div class="control">
            <input :value="receiver" class="input" type="text" disabled />
          </div>
        </div>

        <div class="field">
          <label class="label">Ημερομηνία</label>
          <div class="control">
            <input
              :value="contact.created_at | timestamp"
              class="input"
              type="text"
              disabled
            />
          </div>
        </div>

        <div class="field">
          <label class="label">Τίτλος</label>
          <div class="control">
            <input :value="contact.title" class="input" type="text" disabled />
          </div>
        </div>

        <div class="field">
          <label class="label">Τύπος</label>
          <div class="control">
            <input :value="type" class="input" type="text" disabled />
          </div>
        </div>

        <div class="field">
          <label class="label">Περιεχόμενο</label>
          <div class="control">
            <textarea
              :value="contact.content"
              class="textarea"
              type="text"
              Z
              disabled
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';

export default {
  name: 'ContactPreview',
  props: {
    isOpen: false,
    customer: Object,
    contact: Object,
    contactTypes: Array,
  },
  computed: {
    receiver() {
      return `${this.customer.fullName} | ${this.customer.email}`;
    },
    type() {
      return _get(this.contact, 'type.title', 'Ask the experts');
    },
  },
  methods: {
    closeModal(deleteResponse) {
      this.$emit('closeModal', deleteResponse);
    },
  },
};
</script>
